<template>
  <div v-if="user">
    <page-header>
      <template #title>
        <h1 class="page-title">Defleet</h1>
      </template>
      <template #actions>
        <page-header-action
          tag="form-button"
          :indicator="downloading"
          @clicked="download"
        >
          Download Export
        </page-header-action>
      </template>
    </page-header>
    <div class="card mb-3">
      <div class="card-header">
        <div class="clearfix" style="width: 100%;">
          <div class="row">
            <div class="col-md-4 pb-2">
              <selectlist
                :value="filters.group_id"
                @input="setGroup"
                name="group_id"
                label="Group"
                :options="groups"
                :stacked="true"
                label-name="name"
              ></selectlist>
            </div>
            <div class="col-md-4 pb-2">
              <selectlist
                :value="filters.hire_site_id"
                @input="setHireSite"
                name="hire_site_id"
                label="Hire Site"
                label-name="name"
                :stacked="true"
                :options="hireSites"
              ></selectlist>
            </div>
            <div class="col-md-4 pb-2">
              <selectlist
                :value="filters.make_id"
                @input="setMake"
                name="make_id"
                label="Make"
                :stacked="true"
                :options="makes"
              ></selectlist>
            </div>
            <div class="col-md-4 pb-2">
              <selectlist
                :value="filters.transmission_id"
                @input="setTransmission"
                name="transmission_id"
                label="Transmission"
                :stacked="true"
                :options="transmissions"
              ></selectlist>
            </div>
            <div class="col-md-8 pb-2">
              <label class="control-label">Registration:</label>
              <input
                name="terms"
                type="text"
                class="form-control"
                :value="filters.terms"
                @input="setTerms($event.target.value)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="loading-overlay" v-if="loading"></div>
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>Registration</th>
              <th>Vehicle Group</th>
              <th>Make</th>
              <th>Model</th>
              <th>Transmission</th>
              <th>Hire Site</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-bind:key="index" v-for="(vehicle, index) in vehicles">
              <td v-text="vehicle.registration"></td>
              <td>{{ vehicle.group?.name }}</td>
              <td>{{ vehicle | make }}</td>
              <td v-text="vehicle.model"></td>
              <td>{{ vehicle.transmission?.label || 'Not Selected' }}</td>
              <td>{{ vehicle.hire_site?.name }}</td>
              <td>{{ vehicle.status?.label }}</td>
              <td>
                <!--              <router-link-->
                <!--                  class="btn btn-primary"-->
                <!--                  :to="`/fleet/${vehicle.identifier}/edit`"-->
                <!--              >-->
                <!--                Edit-->
                <!--              </router-link>-->
                <router-link
                  class="btn btn-warning"
                  :to="`/fleet/${vehicle.identifier}`"
                >
                  View
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer text-right">
        <pagination
          :data="paginator_data"
          v-on:updateResults="getData"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import PageHeader from './../Shared/PageHeader.vue';
import PageHeaderAction from './../Shared/PageHeaderAction.vue';

export default {
  components: {
    PageHeader,
    PageHeaderAction
  },

  data() {
    return {
      vehicles: [],
      paginator_data: {},
      filters: {
        group_id: '',
        status_id: '',
        make_id: '',
        transmission_id: '',
        hire_site_id: '',
        terms: '',
        defleeted: true
      },
      loading: true,
      indicator: false,
      downloading: false
    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    },

    groups() {
      return this.$store.getters['VehicleGroups/all'].filter(group =>
        group.name.startsWith('B')
      );
    },

    statuses() {
      return this.$store.getters['VehicleStatuses/all'];
    },

    makes() {
      return this.$store.getters['VehicleMakes/all'];
    },

    transmissions() {
      return this.$store.getters['VehicleTransmissions/all'];
    },

    hireSites() {
      return this.$store.getters['HireSites/all'];
    }
  },

  mounted() {
    this.$store.commit('VehicleStatuses/retrieve');
    this.$store.commit('HireSites/retrieve');
    this.loadFleet();
  },

  filters: {
    dateFormat(value) {
      if (value) {
        return window.DateManager.format(value);
      }

      return null;
    },

    make(vehicle) {
      if (vehicle.make) {
        return vehicle.make.label;
      }

      return 'Not Provided';
    }
  },

  methods: {
    loadFleet() {
      let identifier = this.user.tenant?.identifier;

      if (identifier) {
        this.getData(`/fleet/${identifier}?per_page=${this.perPage}`);
      }
    },

    getData(url) {
      this.loading = true;

      Object.keys(this.filters).forEach(key => {
        url = `${url}&filter[${key}]=${this.filters[key]}`;
      });

      window.Ajax.get(url)
        .then(response => {
          this.loading = false;
          this.vehicles = response.data.data;
          this.paginator_data = response.data;
        })
        .catch(err => {});
    },

    setGroup(group) {
      this.filters.group_id = group;

      this.loadFleet();
    },

    setStatus(status) {
      this.filters.status_id = status;

      this.loadFleet();
    },

    setMake(make) {
      this.filters.make_id = make;

      this.loadFleet();
    },

    setTransmission(transmission) {
      this.filters.transmission_id = transmission;

      this.loadFleet();
    },

    setHireSite(hireSite) {
      this.filters.hire_site_id = hireSite;

      this.loadFleet();
    },

    setTerms: debounce(function(terms) {
      this.filters.terms = terms;

      this.loadFleet();
    }, 400),

    download() {
      this.downloading = true;
      let identifier = this.user.tenant?.identifier;

      if (identifier) {
        let url = `/fleet/${identifier}/download`;

        const queryParams = Object.entries(this.filters)
          .map(([key, value]) => `filter[${key}]=${value}`)
          .join('&');

        url += `?${queryParams}`;

        window.Ajax.download(url)
          .then(() => {
            this.downloading = false;
          })
          .catch(error => {
            this.downloading = false;
            window.toastify.error(
              'Error',
              'There was a problem downloading the export, please try again.'
            );
          });
      }
    },
    statusByName(name) {
      return this.statuses.find(status => status.name === name);
    }
  },

  watch: {
    user() {
      this.loadFleet();
    }
  }
};
</script>
